import { render, staticRenderFns } from "./Polygon.vue?vue&type=template&id=0d20c552&scoped=true&"
import script from "./Polygon.vue?vue&type=script&lang=ts&"
export * from "./Polygon.vue?vue&type=script&lang=ts&"
import style0 from "./Polygon.vue?vue&type=style&index=0&id=0d20c552&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d20c552",
  null
  
)

export default component.exports